import React from 'react';
import styled from '@emotion/styled';
import { Icon } from '@vmos2/design-system';
import { useTranslation } from 'react-i18next';
import { withTheme } from '@emotion/react';
import get from 'lodash/get';
import isEmpty from 'lodash/isEmpty';
import toLower from 'lodash/toLower';
import { getTransactionInformation } from './utils';


type Props = {
  className?: string,
  last4: string,
  walletType?: string,
  brand: string,
  walletEmail?: string,
  date: string,
  status: string,
  paymentProvider: string,
  transactionType: string,
  theme: Object,
};


const PaymentDetails = ({
  className,
  last4,
  walletType,
  brand,
  walletEmail,
  date,
  status,
  paymentProvider,
  transactionType,
  theme,
}: Props) => {
  const { t } = useTranslation('order.details');

  if (paymentProvider === 'free') {
    return (
      <InfoWrapper className={className} data-test="payment-details-no-payment-required">
        <InfoIcon name="InfoCircle" />
        {t('noPaymentRequired')}
      </InfoWrapper>
    );
  }
  const allowedTransactionStatuses = ['success', 'success-adjustment', 'preauthorized'];
  if (
    !allowedTransactionStatuses.includes(status) ||
    paymentProvider === 'toggle' ||
    paymentProvider === 'edenred' ||
    transactionType === 'refund'
  )
    return null;

  const icon = get(theme, ['paymentCards', toLower(brand)]);

  return (
    <Wrapper className={className} data-test="payment-details-container">
      <PaymentStatus>
        {t('paymentReceived')}
        {getTransactionInformation(walletType, last4, t('cardEnding'))}
        {!isEmpty(icon) && !walletType && <Logo src={icon} />}
      </PaymentStatus>
      {walletEmail && <PaymentStatus>{walletEmail}</PaymentStatus>}
      {t('date')}: {date}
    </Wrapper>
  );
};

const Wrapper = styled('div')`
  font-size: ${({ theme }) => theme.fontSize.sm};
  color: ${({ theme }) => theme.color.grey};

  @media (${({ theme }) => theme.breakpoint.tablet}) {
    font-size: ${({ theme }) => theme.fontSize.md};
  }
`;

const PaymentStatus = styled('p')`
  font-size: ${({ theme }) => theme.fontSize.md};
  display: flex;
  align-items: center;
  margin: 0 0 8px 0;

  @media (${({ theme }) => theme.breakpoint.tablet}) {
    font-size: ${({ theme }) => theme.fontSize.lg};
  }
`;

const Logo = styled('img')`
  margin-left: 8px;
`;

const InfoWrapper = styled('div')`
  display: flex;
  align-items: center;
  font-size: ${({ theme }) => theme.fontSize.sm};

  @media (${({ theme }) => theme.breakpoint.tablet}) {
    font-size: ${({ theme }) => theme.fontSize.md};
  }
`;

const Reason = styled('div')`
  color: ${({ theme }) => theme.color.danger};
`;

const InfoIcon = styled(Icon)`
  margin-right: 8px;
  font-size: 20px;
  flex: 0 0 20px;
`;

export default withTheme(PaymentDetails);
